import React from "react";
import Header from './components/header.js';
import HeadingPress from './components/heading-page.js';

const Press = () => {
    return (
        <div className="body">
            <div className="grid-pattern">
                <Header />
                <HeadingPress />
            </div>
        </div>
    );
};

export default Press;
